import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { PartnerDetails } from 'apis/PartnerApi';
import { Alert } from 'react-bootstrap';

type MergeReviewStepProps = {
    sourcePartner: PartnerDetails;
    targetPartner: PartnerDetails;
};

export const MergeReviewStep = (props: MergeReviewStepProps) => {

    const { sourcePartner, targetPartner } = props;

    const intl = useIntl();

    const renderDate = (date: Date | string | null) => {

        if (!date) return '—';
        return intl.formatDate(new Date(date), { day: 'numeric', month: 'short', year: 'numeric' });

    };

    return (
        <div className="merge-review-step mt-3">
            <p className="text-muted mb-3">
                {<FormattedMessage defaultMessage="Select the account you would like to keep." id="select_the_account_you_would_like_to_kee.1dac1d4c" /> || 'Review the details below before proceeding. The target Testing Center\'s data will be merged into the source Testing Center.'}
            </p>

            <div className="merge-review-columns">
                <div className="merge-review-card merge-review-card--source">
                    <div className="merge-review-card__header merge-review-card__header--source">
                        <i className="fa-solid fa-building me-2" />
                        {<FormattedMessage defaultMessage="Account to Keep" id="account_to_keep.980b996d" /> || 'Source'}
                    </div>
                    <div className="merge-review-card__body">
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Organization" description="New" id="organization.7cb537a9" /> || 'Organization'}
                            </span>
                            <span className="merge-review-card__value">
                                {sourcePartner.Name}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                <FormattedMessage defaultMessage="ID" id="id.e9650a61" />
                            </span>
                            <span className="merge-review-card__value">
                                {sourcePartner.ID}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Email" id="email.500d9e86" /> || 'Email'}
                            </span>
                            <span className="merge-review-card__value">
                                {sourcePartner.ContactEmail || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Customer ID" description="New" id="customer_id.16ab92c3" /> || 'Customer ID'}
                            </span>
                            <span className="merge-review-card__value">
                                {sourcePartner.CustomerIDString || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Sector" description="New" id="sector.343b1273" /> || <FormattedMessage defaultMessage="Sector" id="sector.99a79448" /> || 'Sector'}
                            </span>
                            <span className="merge-review-card__value">
                                {sourcePartner.SectorName || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Country" description="New" id="country.05543f81" /> || <FormattedMessage defaultMessage="Country" id="country.cfeb54cc" /> || 'Country'}
                            </span>
                            <span className="merge-review-card__value">
                                {sourcePartner.Country?.Name || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                <FormattedMessage defaultMessage="State/Province" id="stateprovince.d2dfa3c8" />
                            </span>
                            <span className="merge-review-card__value">
                                {sourcePartner.State?.Name || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Status" id="status.ad856ad7" /> || 'Status'}
                            </span>
                            <span className="merge-review-card__value">
                                {sourcePartner.Active ? (
                                    <span className="badge bg-success">
                                        {<FormattedMessage defaultMessage="Active" id="active.b9616c88" /> || 'Active'}
                                    </span>
                                ) : (
                                    <span className="badge bg-secondary">
                                        {<FormattedMessage defaultMessage="Inactive" description="New" id="inactive.5ee46a1c" /> || 'Inactive'}
                                    </span>
                                )}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Date Created" id="date_created.85efe6f3" /> || 'Created'}
                            </span>
                            <span className="merge-review-card__value">
                                {renderDate(sourcePartner.DateCreate)}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="merge-review-card merge-review-card--target">
                    <div className="merge-review-card__header merge-review-card__header--target">
                        <i className="fa-solid fa-right-to-bracket me-2" />
                        {<FormattedMessage defaultMessage="Account to Merge" id="account_to_merge.20112764" /> || 'Merge'}
                    </div>
                    <div className="merge-review-card__body">
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Organization" description="New" id="organization.7cb537a9" /> || 'Organization'}
                            </span>
                            <span className="merge-review-card__value">
                                {targetPartner.Name}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                <FormattedMessage defaultMessage="ID" id="id.e9650a61" />
                            </span>
                            <span className="merge-review-card__value">
                                {targetPartner.ID}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Email" id="email.500d9e86" /> || 'Email'}
                            </span>
                            <span className="merge-review-card__value">
                                {targetPartner.ContactEmail || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Customer ID" description="New" id="customer_id.16ab92c3" /> || 'Customer ID'}
                            </span>
                            <span className="merge-review-card__value">
                                {targetPartner.CustomerIDString || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Sector" description="New" id="sector.343b1273" /> || <FormattedMessage defaultMessage="Sector" id="sector.99a79448" /> || 'Sector'}
                            </span>
                            <span className="merge-review-card__value">
                                {targetPartner.SectorName || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Country" description="New" id="country.05543f81" /> || <FormattedMessage defaultMessage="Country" id="country.cfeb54cc" /> || 'Country'}
                            </span>
                            <span className="merge-review-card__value">
                                {targetPartner.Country?.Name || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                <FormattedMessage defaultMessage="State/Province" id="stateprovince.d2dfa3c8" />
                            </span>
                            <span className="merge-review-card__value">
                                {targetPartner.State?.Name || '—'}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Status" id="status.ad856ad7" /> || 'Status'}
                            </span>
                            <span className="merge-review-card__value">
                                {targetPartner.Active ? (
                                    <span className="badge bg-success">
                                        {<FormattedMessage defaultMessage="Active" id="active.b9616c88" /> || 'Active'}
                                    </span>
                                ) : (
                                    <span className="badge bg-secondary">
                                        {<FormattedMessage defaultMessage="Inactive" description="New" id="inactive.5ee46a1c" /> || 'Inactive'}
                                    </span>
                                )}
                            </span>
                        </div>
                        <div className="merge-review-card__field">
                            <span className="merge-review-card__label">
                                {<FormattedMessage defaultMessage="Date Created" id="date_created.85efe6f3" /> || 'Created'}
                            </span>
                            <span className="merge-review-card__value">
                                {renderDate(targetPartner.DateCreate)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <Alert className="mt-3 d-flex align-items-start" variant="warning">
                <i className="fa-solid fa-triangle-exclamation me-2 mt-1" />
                <div>
                    <strong>
                        {<FormattedMessage defaultMessage="Warning" id="warning.64b35335" /> || 'Warning'}
                        :
                    </strong>
                    <ul className="mb-0 mt-1">
                        <li>
                            {<FormattedMessage defaultMessage="All orders, licenses, and users will be transferred to the source" id="all_orders_licenses_and_users_will_be_tr.9daa418e" /> || 'All orders and licenses from the target will be transferred to the source'}
                        </li>
                        <li>
                            <FormattedMessage
                                values={{
                                    b: chunks => (
                                        <strong>
                                            {chunks}
                                        </strong>
                                    ),
                                    targetName: targetPartner.Name
                                }} defaultMessage="Testing Center {targetName} will be <b>deactivated</b>"
                                id="testing_center_targetname_will_be_deacti.075661dd"
                            />
                        </li>
                    </ul>
                </div>
            </Alert>
        </div>
    );

};
